function DeviceEnrolleeItem(aDevice) {
    "use strict";
    this.__type = 'Device:www.veritracks.com';
    this.Id = aDevice.Id;
    this.Version = aDevice.Version;

    this.CarrierId = aDevice;
    this.IsActive = aDevice;
    this.IsInUse = aDevice.IsInUse;
    this.Mode = aDevice.Mode;
    this.OrganizationId = aDevice.OrganizationId;
    this.OrganizationName;
    this.ProductId = aDevice.ProductId;
    this.ProductName;
    this.ProductType = aDevice.ProductType;
    this.SerialNumber = aDevice.SerialNumber;
    this.Status = aDevice.Status;
    this.STTotalTests = aDevice.STTotalTests;
    this.DaysInSchema = aDevice.DaysInSchema;
    this.EnrolleeName = '';
    this.Enrollee = null;
    this.LastContact = '';
    this.BatteryLevel = '';
    this.MessageGap = '';
	this.DeviceDetailContactDisplay = 'none';
    this.DeviceDetailEnrolleeDisplay = 'none';
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    this.DualCarrierFlag = aDevice.DualCarrierFlag;
    this.DeviceDualCarrierDisplay = 'CallIconProperty';
    this.DeviceStatusDisplay = 'none';
    this.UserId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceEnrolleeItem;
}